<template>
  <div class="editor">
    <!-- {{ newUnit }} -->
    <CloseButton @close="$emit('call-editor', 'close')" />
    <div class="-header">
      <div class="--title">
        <span>{{ mode === "edit" ? "Edit" : "Add" }} Unit</span>
      </div>
      <span class="--subtitle">{{ mode === "edit" ? "แก้ไข" : "เพิ่ม" }} หน่วยการเรียน</span>
    </div>

    <div class="-body">
      <Block no-border>
        <InputBox
          label="หน่วยการเรียน"
          :edata="newUnit['seq']"
          prop="seq"
          @input="handleInput"
          data-type="number"
        />
      </Block>

      <Block no-border>
        <InputBox
          label="ชื่อหัวข้อ"
          :edata="newUnit['nameLocal']"
          prop="nameLocal"
          @input="handleInput"
        />
      </Block>

      <Block no-border>
        <TextArea
          label="รายละเอียด"
          :edata="newUnit['descriptionLocal']"
          prop="descriptionLocal"
          @input="handleInput"
          styles="height: 300px"
        />
      </Block>

      <BlockGroup inline>
        <Block no-border>
          <InputBox
            label="คะแนน Pretest"
            :edata="newUnit['preTestExpectScore']"
            prop="preTestExpectScore"
            @input="handleInput"
            data-type="number"
          />
        </Block>

        <Block no-border>
          <InputBox
            label="คะแนน Posttest"
            :edata="newUnit['postTestExpectScore']"
            prop="postTestExpectScore"
            @input="handleInput"
            data-type="number"
          />
        </Block>
      </BlockGroup>

      <Block no-border>
        <TextArea
          label="วัตถุประสงค์"
          :edata="newUnit['unitObjective']"
          prop="unitObjective"
          @input="handleInput"
          styles="height: 300px"
        />
      </Block>

      <Block no-border>
        <TextArea
          label="สิ่งที่คาดหวัง"
          :edata="newUnit['unitAgenda']"
          prop="unitAgenda"
          @input="handleInput"
          styles="height: 300px"
        />
      </Block>


      <Block no-border>
        <TextArea
          label="หนังสืออ้างอิง/อ่านเพิ่มเติม"
          :edata="newUnit['unitReference']"
          prop="unitReference"
          @input="handleInput"
          styles="height: 300px"
        />
      </Block>

      <div class="--controllers">
        <vs-button @click="saveData">Save</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import Block from "@/components/common-ui/block/index.vue";
import BlockGroup from "@/components/common-ui/block-group/index.vue";
import InputBox from "@/components/common-ui/forms/input-box/index.vue";
import TextArea from "@/components/common-ui/forms/textarea/index.vue";

import {
  addCourseOutlineUnit,
  updateCourseOutlineUnit
} from "@/services/api/course-outline";

export default {
  props: {
    mode: String,
    edata: Object,
  },
  components: {
    CloseButton: () => import("./editor-close"),
    Block,
    BlockGroup,
    InputBox,
    TextArea
  },
  data() {
    return {
      assessmentOptions: [{ id: "", title: "" }],
      newUnit: {
        courseOutlineId: "",
        seq: 0,
        nameLocal: "",
        nameEng: "",
        descriptionLocal: "",
        descriptionEng: "",
        preTestExpectScore: 0,
        postTestExpectScore: 0,
        unitAgenda: "",
        unitObjective: "",
        unitReference: "",
      }
    }
  },
  methods: {
    async saveData() {
      let res = null;
      if (this.mode === "edit") {
        res = await updateCourseOutlineUnit(this.newUnit);
      } else {
        res = await addCourseOutlineUnit(this.newUnit);
      }
      if (res) {
        this.$emit("call-editor", "close");
      }
    },
    handleInput({ prop, data }) {
      this.newUnit[prop] = data;
      this.$forceUpdate();
    }
  },
  mounted() {
    this.newUnit = { ...this.newUnit, ...this.edata };
    if (this.mode === "edit") {
      // this.newAssessment.assessmentId = this.edata.assessment.id;
      // delete this.newAssessment.courseOutline;
      // delete this.newAssessment.mode;
      // delete this.newAssessment.assessment;
      // this.$forceUpdate();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common-scoped";

.editor {
  height: 100vh;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;

  & .-header {
    width: 100%;
    display: block;
    margin-bottom: 20px;

    & .--title {
      font-size: 2rem;
      color: #6f66b9;
      padding-bottom: 1rem;
      width: 100%;
      height: 3rem;
      border-bottom: 2px solid #e8e8e8;
    }
    & .--subtitle {
      margin-top: 1rem;
      font-size: 1rem;
    }
  }

  & .-body {
    display: flex;
    width: 80%;
    flex-direction: column;

    & .--controllers {
      margin-top: 20px;
    }

    & .blocks {
      height: auto !important;
    }
  }
}
</style>